export function showLiveViewModal() {
	 window.location.hash='now-playing'
	 if(window.analytics){
		 window.analytics.page('Now Playing')
	}
}

